import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useHoliday } from "@/context/HolidayContext";

export default function KarfreitagGuard({ children }) {
  const { active } = useHoliday();
  const { pathname } = useLocation();
  const showOverlay = active?.key === "karfreitag" && !pathname.startsWith("/admin");

  // Scroll-Sperre und Fokus-Trap solange das Overlay aktiv ist.
  useEffect(() => {
    if (!showOverlay) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = prev; };
  }, [showOverlay]);

  return (
    <>
      <div aria-hidden={showOverlay || undefined}
        style={showOverlay ? { filter: "blur(10px) grayscale(0.4)", pointerEvents: "none", userSelect: "none" } : undefined}>
        {children}
      </div>
      {showOverlay && (
        <div className="fixed inset-0 z-[9999] bg-white/70 backdrop-blur-md flex items-center justify-center px-6" data-testid="karfreitag-blocker" role="dialog" aria-modal="true">
          <div className="max-w-2xl text-center bg-white/80 backdrop-blur-xl border border-black/10 rounded-3xl px-10 py-14 shadow-[0_20px_80px_rgba(0,0,0,0.15)]">
            <svg width="32" height="42" viewBox="0 0 32 42" className="mx-auto mb-6 text-[#1d1d1b]/80" aria-hidden="true" fill="currentColor">
              <rect x="14" y="0" width="4" height="42" rx="1" />
              <rect x="4" y="10" width="24" height="4" rx="1" />
            </svg>
            <p className="text-lg sm:text-xl leading-relaxed font-light text-[#1d1d1b]">
              Wir gedenken heute dem Sterben Jesu.<br />
              Unsere Website ist am nächsten Tag wieder für Sie erreichbar.
            </p>
          </div>
        </div>
      )}
    </>
  );
}
